import { Alert, Box } from '@mui/material'
import {
  Edit,
  required,
  SimpleForm,
  TextInput,
  useNotify,
  usePermissions,
  useRedirect,
  useTranslate,
} from 'react-admin'

const GroupEdit = () => {
  const notify = useNotify()
  const redirect = useRedirect()
  const translate = useTranslate()
  const { permissions, isLoading } = usePermissions()

  // Only vetadmin can edit groups
  const canEdit = permissions?.role === 'vetadmin'

  const onSuccess = (data: any) => {
    notify('resources.groups.notifications.updated', { type: 'success' })
    redirect('show', 'groups', data.id)
  }

  const onError = (error: any) => {
    console.error('Group update error:', error)
    if (error?.status === 403) {
      notify('resources.groups.errors.forbidden', { type: 'error' })
    } else {
      notify('ra.notification.http_error', { type: 'error' })
    }
  }

  // Block access for non-vetadmin users
  if (!isLoading && !canEdit) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{translate('resources.groups.errors.no_create_permission')}</Alert>
      </Box>
    )
  }

  return (
    <Edit mutationOptions={{ onSuccess, onError }}>
      <SimpleForm>
        <TextInput
          source="name"
          validate={required()}
          fullWidth
          helperText={translate('resources.groups.fields.name_helper')}
        />
        <TextInput
          source="description"
          multiline
          rows={3}
          fullWidth
          helperText={translate('resources.groups.fields.description_helper')}
        />
      </SimpleForm>
    </Edit>
  )
}

export default GroupEdit
